<div
  class="multiple-titles__item"
  (mouseenter)="showPopoverTitle()"
  (mouseleave)="hidePopoverTitle()"
  id="upcoming-popover-{{ title.titleId }}{{ isNewAssets ? '-new-asset' : '' }}"
  (click)="titleClick($event, title)"
>
  <div
    class="multiple-titles__item--image"
    [style.backgroundImage]="'url(' + getThumbnailUrl(title.thumbnailUrl) + ')'"
  >
    <span class="multiple-titles__item--title" *ngIf="showTitle">{{
      title.localTitleName ?? title.titleName
    }}</span>
  </div>
</div>
<dx-popover
  target="#upcoming-popover-{{ title.titleId }}{{ isNewAssets ? '-new-asset' : '' }}"
  position="right"
  width="350"
  [(visible)]="hoverPopup"
  [wrapperAttr]="{ id: 'home-title-popover' }"
>
  <div
    *dxTemplate="let data = model; of: 'content'"
    class="home-title-popover__content"
    (mouseenter)="showPopover()"
    (mouseleave)="hidePopover()"
  >
    <dx-scroll-view showScrollbar="onScroll">
      <div class="home-title-popover__title">
        <span>{{ title.localTitleName ?? title.titleName }}</span>
      </div>
      <div class="home-title-popover__details--item" *ngIf="title.assetCategories">
        <div class="home-title-popover__details--recentlyAdded">
          {{ 'recently-added-label' | translate }}
        </div>
        <span *ngFor="let category of categories"
          ><ul class="home-title-popover__details--newitem">
            {{
              category
            }}
          </ul></span
        >
      </div>
      <div class="home-title-popover__details">
        <div
          class="home-title-popover__details--synopsis"
          *ngIf="title.displaySynopsisInd === 1 && title.synopsis"
        >
          <span class="d-block"
            ><b>{{ 'synopsis-label' | translate }}</b></span
          >
          <span
            class="home-title-popover__details--synopsis--item"
            [innerHTML]="title.synopsis"
          ></span>
          <a
            [routerLink]="['/assets/' + title.titleId]"
            [queryParams]="{ isReadMore: 'true' }"
            class="link-title" (click)="this.googleanalyticsmoduleserviceService.sendDataToAnalyticsOnHomePageTitleClick(title,isNewAssets)"
            >Read more..</a
          >
        </div>
        <div class="home-title-popover__details--item" *ngIf="formattedReleaseDate">
          <span
            ><b>{{ 'release-date-label' | translate }}</b></span
          >
          <span class="ps-4">{{ formattedReleaseDate }}</span>
        </div>
        <div class="home-title-popover__details--item" *ngIf="formattedFirstPreviewDate">
          <span
            ><b>{{ 'first-preview-date-label' | translate }}</b></span
          >
          <span class="ps-4">{{ formattedFirstPreviewDate }}</span>
        </div>
        <div
          class="home-title-popover__details--item"
          *ngIf="title.displayRatingInd === 1 && title.censorCode"
        >
          <span
            ><b>{{ 'rating-label' | translate }}</b></span
          >
          <span class="ps-4">{{ title.censorCode }}</span>
        </div>
        <div
          class="home-title-popover__details--item"
          *ngIf="title.displayRuntimeInd === 1 && title.runningTime"
        >
          <span
            ><b>{{ 'run-time-label' | translate }}</b></span
          >
          <span class="ps-4">{{ title.runningTime + ' min' }}</span>
        </div>
        <div class="home-title-popover__details--item" *ngIf="title.hashtag">
          <span
            ><b>{{ 'hashtags-label' | translate }}</b></span
          >
          <span class="ps-4">{{ title.hashtag }}</span>
        </div>
        <div class="home-title-popover__details--item" *ngIf="title.website?.trim()">
          <span
            ><b>{{ 'website-label' | translate }}</b></span
          >
          <div [innerHTML]="getWebsite(title.website) | split"></div>
        </div>
      </div>
    </dx-scroll-view>
  </div>
</dx-popover>
